import { styled } from "@grupoboticario/flora-react";

export const FooterContainer = styled("div", {
    borderTop: "1px solid ghostwhite",
    padding: "0px 15px",
    display: "flex",
    background: "rgb(54, 67, 114)",
    justifyContent: "center",
    alignItems: "center",
    height: "34px"
})

export const FooterLeft =  styled("div", {})
export const FooterRight =  styled("div", {
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
    flex: 1,
    "& Button": {
        background: "transparent",
        "&:hover": {
            background: "transparent !important",
        }
    }
})
export const FooterCenter =  styled("div", {
    display: "flex",
    "& Button": {
        background: "transparent",
        "&:hover": {
            background: "transparent !important",
        }
    }
})